<template>
  <div>
    <el-row class="movie-list">
      <el-col :md="20">
        <el-row>
          <h2>我的消息</h2>
          <el-button
            size="mini"
            type="danger"
            @click="handleClear"
          >清空</el-button>
        </el-row>
        <el-card>
          <el-table
            :data="dataList"
            :show-header="true"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="createTime"
              label="时间"
            />
            <el-table-column
              prop="title"
              label="标题"
            />
            <el-table-column
              label="操作"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="view(scope.row)"
                >查看</el-button>
                <el-button
                  size="mini"
                  @click="delete(scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog title="消息内容" :visible.sync="messageDialog" @close="onCloseDialog">
      <span>{{ messageContent }}</span>
    </el-dialog>
  </div>
</template>

<script>
import { getUnreadMessages, getMessageDetail, clearMessages } from '@/api/user'

export default {
  name: 'MyMessage',
  data() {
    return {
      dataList: [],
      messageDialog: false,
      messageContent: ''
    }
  },
  created() {
    document.title = '我的消息'
    this.getData()
  },
  methods: {
    getData() {
      var queryParams = {}
      queryParams.pn = 1
      getUnreadMessages(queryParams).then(resp => {
        if (resp.code === 0) {
          this.dataList = resp.data
        }
      })
    },
    view(row) {
      var queryParams = {}
      queryParams.messageId = row.messageId
      getMessageDetail(queryParams).then(resp => {
        if (resp.code === 0) {
          this.messageDialog = true
          this.messageContent = resp.data.content
        }
      })
    },
    onCloseDialog() {
      this.messageContent = ''
    },
    handleClear() {
      this.$confirm('确定要清空所有消息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        clearMessages().then(resp => {
          if (resp.code === 0) {
            this.getData()
          }

          this.$message.info(resp.msg)
        })
      }).catch(() => {
        this.$message.info('已取消')
      })
    }
  }
}
</script>

<style scoped>
/*处于手机屏幕时*/
@media screen and (max-width: 768px) {
  .movie-list {
    padding-top: 8px;
    padding-left: 0.5%;
    padding-right: 0.5%;
  }
}

.movie-list {
  padding-top: 15px;
  padding-left: 6%;
  padding-right: 6%;
}
</style>
